import { render, staticRenderFns } from "./FolderUpdateModal.vue?vue&type=template&id=73635a80&scoped=true"
import script from "./FolderUpdateModal.vue?vue&type=script&lang=ts"
export * from "./FolderUpdateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73635a80",
  null
  
)

export default component.exports